import Vue from 'vue';
import Router from 'vue-router';
import i18n from './i18n';

import App from './App';
import Main from '@/components/pages/Main';
import Widget from '@/components/pages/Widget';
import NotFound from '@/components/pages/404';
import langs from '@/constants/langs.json';


Vue.use(Router);

export const insideIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const router = new Router({
  routes: [
    {
      path: '/:lang',
      component: App,
      beforeEnter: (to, from, next) => {
        const lang = to.params.lang;
        if (!langs.includes(lang)) {
          return next(langs[0]);
        }
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
      children: [
        {
          path: '',
          name: 'map',
          component: Main,
          beforeEnter: (to, from, next) => insideIframe()
            ? next(`/${i18n.locale}/not_found`)
            : next(),
        },
        {
          path: 'not_found',
          name: '404',
          component: NotFound,
        },
        {
          path: 'widget/:id',
          name: 'widget',
          component: Widget,
          beforeEnter: (to, from, next) => insideIframe()
            ? next()
            : next(`/${i18n.locale}/${to.params.id}`),
        },
        {
          path: ':id',
          name: 'sensor',
          component: Main,
          beforeEnter: (to, from, next) => insideIframe()
            ? next(`/${i18n.locale}/widget/${to.params.id}`)
            : next(),
        },
      ],
    },
    {
      path: '*',
      redirect: `/${langs[0]}`,
    },
  ],
  mode: 'history',
});

export default router;
